import { z } from 'zod';
import { PaymentMethod } from '../enums.js';
import { paginationQuerySchema } from '../pagination.js';
import { optionalString, optionalId } from './common.js';
export const saleItemSchema = z.object({
    sparePartId: optionalId(),
    label: z.string().trim().min(1, 'Libellé requis').max(200),
    quantity: z.coerce.number().int().min(1),
    unitPriceCents: z.coerce.number().int().min(0),
    taxRate: z.coerce.number().min(0).max(100).default(0),
    discountCents: z.coerce.number().int().min(0).default(0),
});
export const salePaymentSchema = z.object({
    method: z.nativeEnum(PaymentMethod),
    amountCents: z.coerce.number().int().min(0),
    reference: optionalString(100),
});
export const createSaleSchema = z.object({
    customerId: optionalId(),
    items: z.array(saleItemSchema).min(1, 'Panier vide'),
    // Tableau vide = vente à crédit (mise en compte) ; customerId obligatoire dans ce cas.
    payments: z.array(salePaymentSchema).min(0),
}).refine((d) => d.payments.length > 0 || !!d.customerId, { message: 'Un compte client est requis pour une vente à crédit', path: ['customerId'] });
export const salesQuerySchema = paginationQuerySchema.extend({
    customerId: z.string().optional(),
    from: z.coerce.date().optional(),
    to: z.coerce.date().optional(),
});
//# sourceMappingURL=sale.js.map